<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      @if (displayFees) {
        <div class="col col-md-12">
          <pr-input-column
            label="Frais appliqués à la souscription"
            [derrors]="derrors"
          >
            <input
              formControlName="fees"
              type="number"
              min="{{ minFees }}"
              max="{{ maxFees }}"
              fraction="2"
            />
            <i>%</i>
          </pr-input-column>
        </div>
      }

      <div class="col col-md-12">
        <pr-input-date
          label="Date de signature"
          formControlName="dateSignature"
          [derrors]="derrors"
          [isDefault]="false"
        ></pr-input-date>
      </div>
      <div class="col col-md-12">
        <pr-input-column
          label="Lieu de signature (France uniquement)"
          [derrors]="derrors"
          [readonly]="placeSignatureLocked"
        >
          <input
            formControlName="placeSignature"
            type="text"
            [readonly]="placeSignatureLocked"
          />
        </pr-input-column>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
